import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';

import { HttpError } from '@bonusly/http';
import { useHttpClient } from '@bonusly/http-client';

import { FilterOptionsGroup, filterOptionsGroupsToFlatRecord } from '../../../queries/analytics-filter-options';

type CustomPropertyInputOptionsResponse = Record<string, string[]>;

type CustomPropertyFilterOptionsResponse = {
	groups: FilterOptionsGroup[];
};

const QueryKey = {
	ManagerInputOptions: 'manager-input-options',
	UserInputOptions: 'user-input-options',
};

export const useManagerInputOptions = (startDate: Date, endDate: Date) => {
	const http = useHttpClient('v2');
	return useQuery<CustomPropertyInputOptionsResponse, HttpError>(
		[
			QueryKey.ManagerInputOptions,
			{
				startDate,
				endDate,
			},
		],
		async () => {
			const response = await http.get<CustomPropertyFilterOptionsResponse>('/analytics/filter_options/manager_custom_properties', {
				params: {
					start_time: format(startDate, 'yyyy-MM-dd'),
					end_time: format(endDate, 'yyyy-MM-dd'),
				},
			});

			return filterOptionsGroupsToFlatRecord(response.data.groups);
		},
		{
			retry: 2,
			refetchOnWindowFocus: false,
			staleTime: 5 * 60 * 1000,
		}
	);
};

export const useUserInputOptions = (startDate: Date, endDate: Date) => {
	const http = useHttpClient('v2');
	return useQuery<CustomPropertyInputOptionsResponse, HttpError>(
		[
			QueryKey.UserInputOptions,
			{
				startDate,
				endDate,
			},
		],
		async () => {
			const response = await http.get<CustomPropertyFilterOptionsResponse>('/analytics/filter_options/user_custom_properties', {
				params: {
					start_time: format(startDate, 'yyyy-MM-dd'),
					end_time: format(endDate, 'yyyy-MM-dd'),
				},
			});

			return filterOptionsGroupsToFlatRecord(response.data.groups);
		},
		{
			retry: 2,
			refetchOnWindowFocus: false,
			staleTime: 5 * 60 * 1000,
		}
	);
};
